import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { LensesDisplayGridRowDataFragment, LensSortOrder, TableDownstreamLensesFilteredByColumnQuery, TableDownstreamLensesFilteredByColumnQueryVariables, TableDownstreamLensesQuery, TableDownstreamLensesQueryVariables , TableDownstreamLensesFilteredByColumnDocument , TableDownstreamLensesDocument } from '../../../../../gen-src/queries';
import { ConnectionListResult, GridSortProps, PaginatedQueryWrapper } from '../../../data-catalog-shared';
import {
  LensesDisplayGrid,
  LensesDisplayGridRowData,
  getRowDataForLens,
} from '../sharedDisplayGrid/LensesDisplayGrid';
import { LensesValidSortFields } from '../sorting/sortProviders/LensesGridSortProvider';

type QueryVariables = TableDownstreamLensesQueryVariables;
type QueryResults = TableDownstreamLensesQuery;
type QueryResultListNode = LensesDisplayGridRowDataFragment;
type GridRowData = LensesDisplayGridRowData;

type QueryVariablesWithFilter = TableDownstreamLensesFilteredByColumnQueryVariables;
type QueryResultsWithFilter = TableDownstreamLensesFilteredByColumnQuery;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData?.tables && resultData.tables[0]?.downstreamLensesConnection;
}

function selectConnectionListResultForFilteredQuery(resultData: QueryResultsWithFilter): ConnectionListResult<QueryResultListNode> | null {
  const table = resultData?.tables && resultData.tables[0];
  return table?.columns && table.columns[0]?.downstreamLensesConnection;
}

export type TableDownstreamLensesQueryGridProps = GridSortProps<LensesValidSortFields> & {
  readonly tableId: string;
  readonly filteredColumnId: string | null;
  readonly rowCount: number | null;
};

export function TableDownstreamLensesQueryGrid(props: TableDownstreamLensesQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamLensesLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredLensesLineageGridMessage();

  return props.filteredColumnId ? (
    <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNode, GridRowData>
      queryGql={TableDownstreamLensesFilteredByColumnDocument}
      partialQueryVariables={{ tableId: props.tableId, columnId: props.filteredColumnId, orderBy: props.orderBy as LensSortOrder }}
      selectConnectionListResult={selectConnectionListResultForFilteredQuery}
      mapResultNode={getRowDataForLens}
    >
      {({ rowStore }) => (
        <LensesDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyFilteredGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      )}
    </PaginatedQueryWrapper>
  ) : (
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={TableDownstreamLensesDocument}
      partialQueryVariables={{ tableId: props.tableId, orderBy: props.orderBy as LensSortOrder }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataForLens}
    >
      {({ rowStore }) => (
        <LensesDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      )}
    </PaginatedQueryWrapper>
  );
}
